$(document).ready(function() {
    if ($('body.archive.woocommerce').length > 0) {
        woocommerceOrdering();
        sidebar();
    }
});

$(window).on('wcpf_update_products', function () {
    woocommerceOrdering();
});


function woocommerceOrdering() {
    var orderingSelect = $('.woocommerce-ordering select');

    orderingSelect.select2({
        minimumResultsForSearch: Infinity
    });

    orderingSelect.on('select2:select', function () {
        $(this).closest('form').submit();
    });
}

function sidebar() {
    var toggle = $('.mobile-filter-toggle');
    var sidebar = $('.row .sidebar');

    toggle.on('click', function () {
        if (sidebar.hasClass('active')) {
            sidebar.removeClass('active');
            $('body').removeClass('fixed');
        } else {
            sidebar.addClass('active');
            $('body').addClass('fixed');
        }
    });

    $('.sidebar .close-sidebar').on('click', function () {
        sidebar.removeClass('active');
        $('body').removeClass('fixed');
    });
}